import React, {useState, useEffect, useRef} from 'react'
import {Link } from "react-router-dom";
import Header from './Header'
import Card from './WatchCard'
import styles from'./traders.module.css'
import Footer from './Footer'
import SubHeader from './SubHeader'
import GoTop from '../helper/GoTop'
export default function Traders() {
    const [scrollPosition, setSrollPosition] = useState(0);
    const [showGoTop, setshowGoTop] = useState("goTopHidden");
    const refScrollUp = useRef();
    const handleVisibleButton = () => {
        const position = window.pageYOffset;
        setSrollPosition(position);
    
        if (scrollPosition > 50) {
          return setshowGoTop("goTop");
        } else if (scrollPosition < 50) {
          return setshowGoTop("goTopHidden");
        }
      };
      useEffect(() => {
        window.addEventListener("scroll", handleVisibleButton);
      });
      const handleScrollUp = () => {
        refScrollUp.current.scrollIntoView({ behavior: "smooth" });
      };
    return (
        <div style={{maxWidth: '1340px', margin: 'auto'}} ref={refScrollUp}>
            <div ></div>
            <Header />
            <SubHeader />
            {/*<Link to={{ pathname: "/salesDesk", state: {param1: "Par1"} }}>
              <button>
              Go to Page 2 
            </button>
            </Link>*/}
            <div className='d-flex flex-wrap justify-content-center' >
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
                <Card />
            </div>
            <Footer />
            <GoTop showGoTop={showGoTop} scrollUp={handleScrollUp} />
        </div>
    )
}
